import { createFileRoute } from "@tanstack/react-router";

import { PROTECTED_ROUTE_OPTIONS } from "../../-common";

import { Protected } from "~/entities/auth";

export const Route = createFileRoute("/{-$locale}/_auth")({
  component: Protected(PROTECTED_ROUTE_OPTIONS.AUTH_LAYOUT),
});
